import styled from 'styled-components';
import { text_m, text_s, mq, button, hideOnPrint } from '_utils/styles';
import { spacing } from '_utils/props';
import { ContentRichText } from '../ContentRichText';

export const Wrapper = styled.div<{ $sendFeedback: boolean }>`
  ${({ theme }) => spacing({ theme, $py: 7 })}
  background-color: ${({ theme }) => theme.colors.all.white};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: ${({ $sendFeedback }) => ($sendFeedback ? `2px solid #DDDEE1;` : `1px solid #DDDEE1;`)};
  ${hideOnPrint}
`;

export const Form = styled.form`
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mq.lessThan('md')} {
    flex-direction: column;
    height: 100px;
  }
`;

export const Title = styled.p`
  ${text_m}
  margin: 0 16px 0;
  ${mq('md')} {
    margin: 0 24px 0;
  }
`;

export const ThanksText = styled.p`
  text-align: center;
  ${text_m}
  ${({ theme }) => spacing({ theme, $px: 2 })}
  ${mq.lessThan('md')} {
      ${text_s}
      margin: 0;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CommentsWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const Label = styled.span<{htmlFor?: string}>`
  display: block;

  margin-right: 16px;
  ${mq('md')} {
    margin-right: 24px;
  }
`;

export const TextArea = styled.textarea`
  ${text_s};
  border: ${({ theme }) => theme.colors.form.input.border};
  height: 88px;
  width: 176px;
  padding: 16px;
  margin-right: 16px;
  border-radius: 4px;
  position: relative;
  ${mq('md')} {
    width: 372px;
    margin-right: 24px;
  }
  &::placeholder {
    color: ${({ theme }) => theme.colors.form.input.border};
  }
  outline: 0;

  /* psuedo focus outline */
  &:focus {
    box-shadow: 0px 0px 0px 2px ${({ theme }) => theme.colors.element.focused};
  }
`;

export const Submit = styled.button`
  ${button('slim', 'primary')}
`;

export const RichText = styled(ContentRichText)`
  ${({ theme }) =>
    spacing({
      theme,
      $pb: 3
    })}
  text-align: center;
  ${mq.lessThan('md')} {
    ${({ theme }) => spacing({ theme, $px: 5 })}
  }
`;
